import { compose, withProps } from 'recompose'
import { InputText } from './index'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

export const format = (value = '') => {
  // this is to ensure that emails when getting
  // submitted are always undercase, complimenting backend validation
  return value.toLowerCase()
}

const enhance = compose(
  withProps({
    format,
  }),
  toReduxFormField('InputEmail'),
)

export default enhance(InputText)
